import { OrderSchema } from "@redotech/redo-model/order-schema";
import * as z from "zod/v4";

export const getOrderById = {
  name: "getOrderById" as const,
  input: z.object({
    orderId: z.string(),
    includeUnfulfilled: z.boolean().nullish().default(false),
  }),
  output: z.object({
    order: OrderSchema,
  }),
};
